export const maxImagePreviewFileSize = 10 * 1024 * 1024;
export const maxSafetensorsFileSize = Math.pow(1024, 3);
